<template>
    <div>
        <b-modal id="compare-employee" size="lg" body-class="p-0" title="Personel Kontrol" hide-footer no-close-on-esc no-close-on-backdrop>
            <advance-payment-group-key-compare type="bes" v-on:refresh="refresh" :sterling="compare" :table-refresh="tableRefresh"></advance-payment-group-key-compare>
        </b-modal>

        <b-modal id="update-date" title="Ödeme Tarihini Güncelle" no-close-on-esc no-close-on-backdrop>
            <advance-payment-group-key-update-date v-model="date"></advance-payment-group-key-update-date>
            <template #modal-footer><v-executer :loading="dateUpdating" :action="updatePaymentDate" text="Güncelle"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    :settings="false"
                    :items-provider="provider"
                    :initial-load="false"
                    :row-class="item => item.TMSTotalAmount != item.FileTotalAmount ? 'bg-light-danger' : null"
                    button-alignment="justify-content-start">
                    <template #additional-actions>
                        <div class="d-flex align-items-center">
                            <button :disabled="refreshing" v-on:click="refresh" class="btn btn-secondary  btn-sm mr-50">
                                <b-spinner v-if="refreshing" small class="mr-50"></b-spinner>
                                {{refreshing ? 'Garanti Sterling sisteminden gelen e-postalar okunuyor ve analiz ediliyor...' : 'Yenile'}}
                            </button>
                            <span>Son Güncelleme Tarihi: <strong>{{ currentDate }}</strong></span>
                        </div>
                    </template>
                </v-table>
    </div>
</template>

<script>
import { BCard, BSpinner } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations';
import moment from 'moment'
import Additional from '@/utilities/additional';
import AdvancePaymentGroupKeyCompare from './components/AdvancePaymentGroupKeyCompare.vue'
import AdvancePaymentGroupKeyUpdateDate from './components/AdvancePaymentGroupKeyUpdateDate.vue'

export default {
    components:{
        BCard,
        BSpinner,
        AdvancePaymentGroupKeyCompare,
        AdvancePaymentGroupKeyUpdateDate
    },
    data(){
        return {
            fields:[
                {name:'Kimlik',key:'GroupKey',tdClass:'text-nowrap'},
                {name:"Banka Detay",thClass:'w-40',component:true,componentOptions:{name:"advance-payment-group-key/BankDetail"}},
                {name:"Detay",thClass:'w-60',component:true,componentOptions:{name:"advance-payment-group-key/AdvancePaymentGroupKey"}},
            ],
            currentDate:moment().format('DD.MM.YYYY HH:mm:ss'),
            refreshing:false,
            buttons:[
                { text:"Personel Kontrol",key:"compare",icon:"UsersIcon",variant:"primary",action:this.compareEmployee},
                { text:"Yeniden Bankaya Gönder",key:"pay",icon:"RepeatIcon",variant:"success",action:this.send, condition:(item) => (item.Count > 0 && item.StatusId != 1 && item.StatusId!=6 && item.StatusId!=12 && item.StatusId!=10 && item.StatusId!=9) || (item.StatusId == 4)},
                { text:"Gönder",key:"pay",icon:"SendIcon",variant:"success",action:this.send, condition:(item) => item.Count > 0 && (item.StatusId==12) && item.Sync != false && item.TMSTotalAmount == item.FileTotalAmount},
                { text:"Ödeme Tarihini Güncelle",key:"date",icon:"CalendarIcon",variant:"secondary",action:this.updateDate, condition:(item) => item.Count > 0 && (item.StatusId==4|| item.StatusId == 1||item.StatusId==9||item.StatusId==11)},
                { text:"İptal Et",key:"abort",icon:"XCircleIcon",variant:"secondary",action:this.abort, condition:(item) => item.StatusId!=9&& (item.Count == 0 || item.StatusId==4 ||item.StatusId==1||item.StatusId==11)},
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"secondary",action:this.delete, condition:(item) => item.Count == 0 && item.StatusId==9},
                { text:"Dosya İndir",key:"download",icon:"DownloadIcon",variant:"info",action:this.download, condition:(item) => item.FileDownloadUrl != null && item.StatusId!=1},
                { text:"Dosya Oluştur",key:"download",icon:"ZapIcon",variant:"info",action:this.createFile,condition:(item)=> item.StatusId==12 ||(item.TMSTotalAmount != item.FileTotalAmount) || ((item.StatusId==1||item.StatusId==10) && item.Sync == false)},
                { text:"Finans Ret",key:"financeabort",icon:"XCircleIcon",variant:"warning",action:this.financeAbort, condition:(item) => item.StatusId == 3},
            ],
            dateUpdating:false,
            compare:{},
            date:{
                SterlingId:null,
                Date:null
            }
        }
    },
    mounted(){
        this.refresh()
    },
    methods:{
        tableRefresh(){
            this.$refs.table.refresh()
            this.$hideModal('compare-employee')
        },
        provider(data) {
            return EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyTable({...data,Type:4})
        },
        send(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeySend(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        abort(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyAbort(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        financeAbort(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyFinanceAbort(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        delete(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyDelete(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        },
        download(item){
            this.$refs.table.rowLoading(true)
            Additional.GetBlobFile(item.FileDownloadUrl).then(res=>{
                Additional.DownloadFile(res.data,item.FileName)
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        },
        async refresh(){
            this.refreshing = true
            await EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyCheckStatus()
            this.$refs.table.refresh().then(() => {
                this.refreshing = false
                this.currentDate = moment().format('DD.MM.YYYY HH:mm:ss')
            })
        },
        compareEmployee(item){
            this.compare = {}
            this.compare = item
            this.$showModal('compare-employee')
        },
        updateDate(item){
            this.date.SterlingId = item.Id
            this.date.Date = null
            this.$showModal('update-date')
        },
        updatePaymentDate(){
            this.dateUpdating = true
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyUpdatePaymentDate(this.date).then(res=>{
                this.dateUpdating = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('update-date')
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.dateUpdating = false
                this.$result(null,err)
            })
        },
        createFile(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyGenerate(item.Id).then(res=>{
                this.$refs.table.rowLoading(false)
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.$refs.table.rowLoading(false)
                this.$result(null,err)
            })
        }
    }
}
</script>